/* ============================================
   SPERSONALIZOWANE PREZENTY - JAVASCRIPT
   Plik: spersonalizowane-prezenty.js
   ============================================ */

// Konfiguracja API
const API_ENDPOINT = 'https://api.skomponujprezent.pl/lyrics/generate';

// Inicjalizacja po załadowaniu DOM
document.addEventListener('DOMContentLoaded', function() {
  initializePersonalizationForms();
  initializeFileUploads();
});

/* ============================================
   GŁÓWNA INICJALIZACJA FORMULARZY
   ============================================ */
function initializePersonalizationForms() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');
  
  forms.forEach(form => {
    // Obsługa przycisków AI
    const aiButtons = form.querySelectorAll('.sp-btn-ai');
    aiButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        handleAIGeneration(form, button);
      });
    });

    // Obsługa wyboru opcji AI
    const aiOptions = form.querySelectorAll('.sp-ai-option');
    aiOptions.forEach(option => {
      option.addEventListener('click', () => {
        handleAIOptionSelect(form, option);
      });
    });

    // Walidacja przed wysłaniem
    form.addEventListener('submit', (e) => {
      if (!validateForm(form)) {
        e.preventDefault();
      }
    });

    // Obsługa radio buttons dla kartek
    const cardTypes = form.querySelectorAll('.sp-card-type');
    cardTypes.forEach(cardType => {
      cardType.addEventListener('click', () => {
        handleCardTypeSelect(cardType);
      });
    });
  });
}

/* ============================================
   GENEROWANIE TREŚCI AI
   ============================================ */
async function handleAIGeneration(form, button) {
  // Pobierz dane z formularza
  const formData = collectFormData(form);
  
  // Walidacja wymaganych pól
  if (!validateRequiredFields(form, formData)) {
    showMessage(form, 'Wypełnij wszystkie wymagane pola przed generowaniem AI', 'error');
    return;
  }

  // Pokaż loading
  button.disabled = true;
  const originalText = button.textContent;
  button.innerHTML = 'Generuję...<span class="sp-loading"></span>';

  try {
    // Wywołanie API
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error('Błąd API: ' + response.status);
    }

    const data = await response.json();
    
    // Wyświetl wyniki
    displayAIResults(form, data.variants || []);
    showMessage(form, 'Wygenerowano propozycje! Wybierz jedną z nich.', 'success');

  } catch (error) {
    console.error('Błąd generowania AI:', error);
    showMessage(form, 'Nie udało się wygenerować propozycji. Spróbuj ponownie.', 'error');
  } finally {
    // Przywróć przycisk
    button.disabled = false;
    button.textContent = originalText;
  }
}

/* ============================================
   ZBIERANIE DANYCH Z FORMULARZA
   ============================================ */
function collectFormData(form) {
  const data = {};
  
  // Wszystkie inputy, textareas i selecty
  const fields = form.querySelectorAll('input[name^="properties"], textarea[name^="properties"], select[name^="properties"]');
  
  fields.forEach(field => {
    const name = field.name.match(/properties\[(.*?)\]/)?.[1];
    if (name) {
      if (field.type === 'radio') {
        if (field.checked) {
          data[name] = field.value;
        }
      } else if (field.type === 'checkbox') {
        if (field.checked) {
          data[name] = field.value;
        }
      } else {
        data[name] = field.value;
      }
    }
  });

  // Mapowanie pól na format API
  return {
    person_name: data['Imię osoby obdarowanej'] || data['Imię osoby'] || '',
    occasion: data['Okazja'] || data['Z jakiej okazji'] || '',
    age_role: data['Wiek / rola'] || '',
    interests: data['Zainteresowania / cechy osoby'] || data['Opis relacji'] || '',
    style: data['Styl muzyczny'] || data['Styl'] || '',
    mood: data['Nastrój'] || data['Ton'] || '',
    relation: data['Opis relacji'] || '',
    tone: data['Ton'] || ''
  };
}

/* ============================================
   WYŚWIETLANIE WYNIKÓW AI
   ============================================ */
function displayAIResults(form, variants) {
  const resultsContainer = form.querySelector('.sp-ai-results');
  const optionsContainer = form.querySelector('.sp-ai-options');
  
  if (!resultsContainer || !optionsContainer) return;

  // Wyczyść poprzednie wyniki
  optionsContainer.innerHTML = '';

  // Dodaj nowe opcje
  variants.forEach((text, index) => {
    const option = document.createElement('div');
    option.className = 'sp-ai-option';
    option.dataset.index = index;
    option.dataset.text = text;
    
    const preview = text.length > 200 ? text.substring(0, 200) + '...' : text;
    option.innerHTML = `<p>${preview}</p>`;
    
    option.addEventListener('click', () => {
      handleAIOptionSelect(form, option);
    });
    
    optionsContainer.appendChild(option);
  });

  // Pokaż sekcję wyników
  resultsContainer.classList.add('visible');
}

/* ============================================
   WYBÓR OPCJI AI
   ============================================ */
function handleAIOptionSelect(form, selectedOption) {
  // Usuń poprzednie zaznaczenie
  const allOptions = form.querySelectorAll('.sp-ai-option');
  allOptions.forEach(opt => opt.classList.remove('selected'));
  
  // Zaznacz wybraną opcję
  selectedOption.classList.add('selected');
  
  // Wstaw tekst do textarea
  const text = selectedOption.dataset.text;
  const textarea = form.querySelector('textarea[name*="Tekst"]') || 
                   form.querySelector('textarea[name*="tekst"]');
  
  if (textarea) {
    textarea.value = text;
    textarea.focus();
    
    // Animacja
    textarea.style.background = '#f0fff4';
    setTimeout(() => {
      textarea.style.background = '';
    }, 1000);
  }
}

/* ============================================
   WALIDACJA FORMULARZA
   ============================================ */
function validateForm(form) {
  let isValid = true;
  const requiredFields = form.querySelectorAll('[required]');
  
  requiredFields.forEach(field => {
    if (!field.value.trim()) {
      isValid = false;
      field.style.borderColor = '#e74c3c';
      
      // Usuń czerwoną ramkę po wpisaniu
      field.addEventListener('input', function() {
        this.style.borderColor = '';
      }, { once: true });
    }
  });

  if (!isValid) {
    showMessage(form, 'Proszę wypełnić wszystkie wymagane pola', 'error');
    
    // Przewiń do pierwszego pustego pola
    const firstEmpty = form.querySelector('[required]:invalid, [required][value=""]');
    if (firstEmpty) {
      firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  return isValid;
}

function validateRequiredFields(form, formData) {
  // Podstawowa walidacja - sprawdź czy są jakieś dane
  const hasData = Object.values(formData).some(value => value && value.trim());
  return hasData;
}

/* ============================================
   UPLOAD PLIKÓW (dla grafik AI)
   ============================================ */
function initializeFileUploads() {
  const uploadAreas = document.querySelectorAll('.sp-upload-area');
  
  uploadAreas.forEach(area => {
    const input = area.querySelector('input[type="file"]');
    const preview = area.nextElementSibling;
    
    if (!input) return;

    // Click na obszar = kliknięcie inputa
    area.addEventListener('click', () => {
      input.click();
    });

    // Drag & drop
    area.addEventListener('dragover', (e) => {
      e.preventDefault();
      area.style.borderColor = '#667eea';
      area.style.background = '#f5f7ff';
    });

    area.addEventListener('dragleave', () => {
      area.style.borderColor = '';
      area.style.background = '';
    });

    area.addEventListener('drop', (e) => {
      e.preventDefault();
      area.style.borderColor = '';
      area.style.background = '';
      
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        input.files = files;
        handleFileSelect(input, area, preview);
      }
    });

    // Zmiana pliku
    input.addEventListener('change', () => {
      handleFileSelect(input, area, preview);
    });
  });
}

function handleFileSelect(input, area, preview) {
  const file = input.files[0];
  
  if (!file) return;

  // Walidacja typu pliku
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    alert('Proszę wybrać plik JPG, PNG lub WEBP');
    input.value = '';
    return;
  }

  // Walidacja rozmiaru (max 10MB)
  if (file.size > 10 * 1024 * 1024) {
    alert('Plik jest za duży. Maksymalny rozmiar to 10MB');
    input.value = '';
    return;
  }

  // Pokaż podgląd
  area.classList.add('has-file');
  
  if (preview) {
    const reader = new FileReader();
    reader.onload = (e) => {
      preview.innerHTML = `
        <img src="${e.target.result}" alt="Podgląd zdjęcia">
        <div class="sp-file-name">📎 ${file.name}</div>
      `;
      preview.classList.add('visible');
    };
    reader.readAsDataURL(file);
  }
}

/* ============================================
   WYBÓR TYPU KARTKI
   ============================================ */
function handleCardTypeSelect(cardType) {
  // Usuń poprzednie zaznaczenie
  const allCards = cardType.parentElement.querySelectorAll('.sp-card-type');
  allCards.forEach(card => card.classList.remove('selected'));
  
  // Zaznacz wybraną
  cardType.classList.add('selected');
  
  // Zaznacz radio button
  const radio = cardType.querySelector('input[type="radio"]');
  if (radio) {
    radio.checked = true;
  }
}

/* ============================================
   KOMUNIKATY
   ============================================ */
function showMessage(form, text, type = 'info') {
  // Znajdź lub utwórz kontener na komunikaty
  let messageContainer = form.querySelector('.sp-message');
  
  if (!messageContainer) {
    messageContainer = document.createElement('div');
    messageContainer.className = 'sp-message';
    form.insertBefore(messageContainer, form.firstChild);
  }

  // Ustaw komunikat
  messageContainer.textContent = text;
  messageContainer.className = `sp-message ${type} visible`;

  // Ukryj po 5 sekundach
  setTimeout(() => {
    messageContainer.classList.remove('visible');
  }, 5000);
}

/* ============================================
   UTILITIES
   ============================================ */

// Debounce dla optymalizacji
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Formatowanie ceny
function formatPrice(price) {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN'
  }).format(price);
}

// Sprawdzenie czy użytkownik jest na mobile
function isMobile() {
  return window.innerWidth <= 768;
}

/* ============================================
   ANALITYKA (opcjonalnie)
   ============================================ */
function trackEvent(eventName, eventData = {}) {
  // Integracja z Google Analytics lub innym narzędziem
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, eventData);
  }
  
  console.log('Event tracked:', eventName, eventData);
}

// Przykłady użycia trackEvent:
// trackEvent('ai_generation_started', { product: 'piosenka' });
// trackEvent('ai_option_selected', { option_index: 1 });
// trackEvent('add_to_cart', { product: 'piosenka', price: 149 });

/* ============================================
   EXPORT dla użycia w innych skryptach
   ============================================ */
window.SpersonalizowanePrezenty = {
  collectFormData,
  validateForm,
  showMessage,
  trackEvent
};

console.log('✅ Spersonalizowane Prezenty JS załadowany');